import { Font } from '../../../Resources';

export const Root = styled.div.attrs({ className: 'custom-response' })`
    padding: 10px;
    font-family: ${Font.Default};
    line-height: 1.3;
    justify-content: center;
    align-items: center;
`;
